import { Navigate } from 'react-router-dom';

import { useTenantPlanFeatures } from '../../hooks/useTenantPlanFeatures';
import { ButtonSpinner } from '../ui/Loader';

type Feature = 'numbers' | 'proxies';

/** Blocks admin pages that are outside the tenant subscription plan. */
export function PlanFeatureRoute({
  feature,
  children,
}: {
  feature: Feature;
  children: React.ReactNode;
}) {
  const { hasNumbers, hasProxies, isLoading, isTenant } = useTenantPlanFeatures();

  if (!isTenant) return <>{children}</>;
  if (isLoading) {
    return (
      <div className="min-h-[40vh] flex items-center justify-center">
        <ButtonSpinner />
      </div>
    );
  }

  const allowed = feature === 'numbers' ? hasNumbers : hasProxies;
  if (!allowed) return <Navigate to="/admin" replace />;
  return <>{children}</>;
}
